/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ApplicationMenu from 'ui/components/main-menu/ApplicationMenu.vue';
import EventMenu from 'ui/components/main-menu/EventMenu.vue';
import UserMenu from 'ui/components/main-menu/UserMenu.vue';
import EventStageDescription from 'ui/components/blocks/EventStageDescription.vue';

// Mixins
import { mixin as clickaway } from 'vue-clickaway';
import menuState from 'ui/mixins/menu/menu-state';

/**
 * This component is the root component for the SpotMe CMS main menu.
 *
 * It wraps a dynamic component based on the context of the application.
 * If the `event` is defined then we assume we are in the event space and we
 * include the `EventMenu` component to render the menu. In the case
 * `event` is not set we load `ApplicationMenu` component, which contains links for
 * the application space.
 *
 * @example
 * MainMenu(:user="user" :modules="modules")
 *
 * @vue-prop {String} appName
 * @vue-prop {Object} user the current user object
 * @vue-prop {Object} modules the modules to build the menu from
 * @vue-prop {Object} event the current event object
 * @vue-prop {Object} currentRoute
 *
 * @category ui.components
 * @exports MainMenu
 * @component
 */
const __vue_script__ = {
    name: 'MainMenu',

    components: { ApplicationMenu, EventMenu, UserMenu, EventStageDescription },

    mixins: [clickaway, menuState],

    props: {
        appName: {
            type: String,
            required: true
        },

        user: {
            type: Object,
            required: true
        },

        modules: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            default: () => {}
        },

        currentRoute: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            currentPage: this.currentRoute,
            currentSearchParams: this.$router.getSearchParams(),
            friendlyname: window.BSTG.shortAppName,
            headingUrl: this.$utils.url.getHomeUrl(),
            // If `eventId` is set, then we are in an event space, show the modules.
            menu: this.event ? EventMenu : ApplicationMenu,
            orgId: this.event ? this.event.ownerId : this.$services.org.getFirstRelevantOrg(this.user),
            environment: this.$utils.workspaces.getWorkspaceEnvironment(this.event || {}),
            openTooltip: false,
            eventStage: this.event?.lifecycle?.stage
        };
    },

    created() {
        // We hook into the angular router here in order to keep track of the
        // context changes.
        this.$root.$on('route:change:success', (currentRoute) => {
            this.currentPage = currentRoute.$$route;
            this.currentSearchParams = this.$router.getSearchParams();
        });

        this.$root.$on('route:update', () => {
            this.currentSearchParams = this.$router.getSearchParams();
        });
    },

    methods: {
        /**
         * Opens a new browser window with the webapp preview using current participant
         */
        async getWebappLoginUrl() {
            const webappLoginUrl = await this.$services.user.getWebappLoginUrl(this.event.id);

            return this.$services.router.openNewWindow(webappLoginUrl);
        },

        /**
         * Forces a hard reload of the application to the dashboard.
         */
        goHome($event) {
            // CMD + click or CTRL + click opens in a new tab
            if ($event.metaKey || $event.ctrlKey) {
                return;
            }

            $event.preventDefault();
            this.$router.forcePush(this.headingUrl);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.restoreMenuState),expression:"restoreMenuState"},{name:"browser",rawName:"v-browser"}],staticClass:"main",class:{'submenu-open': _vm.submenuOpen, 'animating': _vm.animating, 'minified': _vm.minified}},[_c('keep-alive',[_c(_vm.menu,{tag:"component",attrs:{"current":_vm.currentPage,"current-search-params":_vm.currentSearchParams,"modules":_vm.modules,"parent-minified":_vm.minified,"event":_vm.event,"org-id":_vm.orgId},on:{"submenu:open":_vm.setSubmenuState,"submenu:selected":_vm.restoreMenuState}},[_c('div',{staticClass:"heading",attrs:{"slot":"heading"},slot:"heading"},[_c('div',{staticClass:"icon"},[_c('a',{attrs:{"href":_vm.headingUrl},on:{"click":_vm.goHome}},[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:({content: _vm.$t('main_menu.logo_tooltip'), delay: {show: 100, hide: 100}, boundariesElement: 'body', classes: 'menu-logo-tooltip'}),expression:"{content: $t('main_menu.logo_tooltip'), delay: {show: 100, hide: 100}, boundariesElement: 'body', classes: 'menu-logo-tooltip'}",modifiers:{"right":true}}],staticClass:"light-only",attrs:{"alt":_vm.friendlyname,"src":_vm.$utils.assets.imagePath('logo.svg')}}),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:({content: _vm.$t('main_menu.logo_tooltip'), delay: {show: 100, hide: 100}, boundariesElement: 'body', classes: 'menu-logo-tooltip'}),expression:"{content: $t('main_menu.logo_tooltip'), delay: {show: 100, hide: 100}, boundariesElement: 'body', classes: 'menu-logo-tooltip'}",modifiers:{"right":true}}],staticClass:"dark-only",attrs:{"alt":_vm.friendlyname,"src":_vm.$utils.assets.imagePath('logo-dark.svg')}})])]),(!_vm.event)?_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":_vm.headingUrl},on:{"click":_vm.goHome}},[_c('img',{staticClass:"light-only",attrs:{"alt":_vm.appName,"src":_vm.$utils.assets.imagePath('spot-me-backstage.svg')}}),_c('img',{staticClass:"dark-only",attrs:{"alt":_vm.appName,"src":_vm.$utils.assets.imagePath('spot-me-backstage-light.svg')}})])]):_c('div',{staticClass:"workspace"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$services.event.getName(_vm.event)))]),_c('div',{staticClass:"stage",class:[_vm.eventStage]},[_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('main_menu.status'))+":")]),_c('div',{staticClass:"stage-name"},[_vm._v(_vm._s(_vm.$utils.strings.capitalize(_vm.environment)))]),_c('i',{staticClass:"tip ic-info-fill",on:{"mouseover":function($event){_vm.openTooltip = true},"mouseleave":function($event){_vm.openTooltip = false}}},[_c('v-popover',{attrs:{"open":_vm.openTooltip,"delay":{show: 100, hide: 100},"placement":"right","popover-class":"tooltip-comp stage-tooltip"}},[_c('template',{slot:"popover"},[_c('event-stage-description',{attrs:{"stage":_vm.eventStage}})],1)],2)],1)]),_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('main_menu.preview_app_tooltip')),expression:"$t('main_menu.preview_app_tooltip')"}],staticClass:"preview",on:{"click":function($event){return _vm.getWebappLoginUrl()}}},[_c('i',{staticClass:"ic-open"})])])]),_c('div',{staticClass:"baseline",attrs:{"slot":"baseline"},slot:"baseline"},[_c('UserMenu',{attrs:{"user":_vm.user,"orgId":_vm.orgId}})],1)])],1),_c('div',{staticClass:"toggler",on:{"click":function($event){return _vm.toggleMenuState(true)}}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MainMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__